import { Component, OnInit } from '@angular/core';
import { MessagesService } from '../../../services/messages.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {
  showMessages: boolean = false;
  
  constructor(
    public _messagesService: MessagesService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.isAllowed();
  }

  isAllowed(){
    this._route.queryParams.subscribe(p =>{
      this.showMessages = p['jlog_show'] == 'Y';
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tools/messages/messages.component.ts